import { PureComponent } from 'react';
import { LoginCardHolder, LoginWrapper, VideoBackground } from './styles';
import { Player } from '@lottiefiles/react-lottie-player';
import Blood from 'assets/images/Blood.jpg';
import BoostingQualityDate from 'assets/images/BoostingQualityDate.jpg';
import BloodMobile from 'assets/images/BloodMobile.jpg';
import defaultBackground from 'assets/films/loginpagebackground.json';
import hand from 'assets/images/hand.jpg';
import handMobile from 'assets/images/handMobile.jpg';
import newYear from 'assets/images/newYear4.jpg';
import ramazan from 'assets/images/ramazan.jpg';
import yalda_back2 from 'assets/images/yalda_back2.jpg';
import LoginCard from './LoginCard/LoginCard';
import { ILoginPageProps, ILoginPageState } from './LoginPage-type';
import { connect, MapDispatchToProps } from 'react-redux';
import { addGuideToList } from 'store/siteGuide/SiteGuideSlice';
import { appDispatch } from 'store/store';
import i18n from '../../i18n';
import { exactWhite } from '../../utils/style/colors';

interface DispatchToProps {
  addGuideToList: (key: string | string[]) => void;
}
type IComponentProps = ILoginPageProps & DispatchToProps;
class LoginPage extends PureComponent<IComponentProps, ILoginPageState> {
  public constructor(props: any) {
    super(props);

    this.state = {
      showAnimation: false,
      activeLanguage: i18n.language,
    };
  }
  public componentDidMount(): void {
    this.props.addGuideToList(['login']);
  }

  public render() {
    const location = window.location;
    const JWTToken = new URLSearchParams(location.search).get('tkn');

    const now = new Date();
    const isYalda =
      now.getMonth() === 11 && now.getDate() < 24 && now.getDate() > 16;
    const isNewYear = now.getMonth() === 2 && now.getDate() > 15;
    const isRamazan = now.getMonth() === 2 && now.getDate() > 10 && !isNewYear; // valid for 1402
    const isHand =
      now.getMonth() === 4 && now.getDate() > 3 && now.getDate() < 7;
    const isBlood =
      now.getMonth() === 5 && now.getDate() > 12 && now.getDate() < 16;
    const isBoostedQualityDate =
      now.getMonth() === 10 && now.getDate() >= 7 && now.getDate() <= 10;
    let background: any = defaultBackground;
    let mobileBackground: any = undefined;

    if (isHand) {
      background = hand;
      mobileBackground = handMobile;
    }
    if (isBlood) {
      background = Blood;
      mobileBackground = BloodMobile;
    } else if (isYalda) {
      background = yalda_back2;
    } else if (isNewYear) {
      background = newYear;
      mobileBackground = newYear;
    } else if (isRamazan) {
      background = ramazan;
    } else if (isBoostedQualityDate) {
      background = BoostingQualityDate;
    }
    const backgroundType = typeof background === 'string' ? 'picture' : 'video';

    return (
      <>
        <LoginWrapper
          className="my-test-wrapper"
          background={backgroundType === 'video' ? exactWhite : background}
          mobileBackground={mobileBackground}
        >
          {backgroundType === 'video' && (
            <VideoBackground>
              <Player
                src={defaultBackground}
                background="transparent"
                speed={1}
                loop
                controls
                autoplay
              />
            </VideoBackground>
          )}
          <LoginCardHolder>
            <LoginCard token={JWTToken} />
          </LoginCardHolder>
          {/*<LangSelector>*/}
          {/*  <APopover*/}
          {/*    arrow*/}
          {/*    curveBorder*/}
          {/*    marginToTarget={12}*/}
          {/*    target={*/}
          {/*      <span style={{ padding: '1rem', cursor: 'pointer' }}>*/}
          {/*        {this.state.activeLanguage.toUpperCase()}*/}
          {/*      </span>*/}
          {/*    }*/}
          {/*    placement={'top'}*/}
          {/*    trigger="click"*/}
          {/*  >*/}
          {/*    <LangContainer>*/}
          {/*      {i18n.options.supportedLngs &&*/}
          {/*        i18n.options.supportedLngs*/}
          {/*          ?.filter((lan: string) => lan !== 'cimode')*/}
          {/*          ?.map((lan: string, index: number) => (*/}
          {/*            <LangItem*/}
          {/*              key={index}*/}
          {/*              href="#"*/}
          {/*              onClick={(e: any) => {*/}
          {/*                e.preventDefault();*/}
          {/*                const activeLanguage =*/}
          {/*                  e.target.innerText.toLowerCase() === 'en'*/}
          {/*                    ? 'en'*/}
          {/*                    : 'fa';*/}
          {/*                i18n.changeLanguage(activeLanguage);*/}
          {/*                this.setState({ activeLanguage });*/}
          {/*                setLangToLocalStorage(activeLanguage);*/}
          {/*              }}*/}
          {/*            >*/}
          {/*              {lan.toUpperCase()}*/}
          {/*            </LangItem>*/}
          {/*          ))}*/}
          {/*    </LangContainer>*/}
          {/*  </APopover>*/}
          {/*</LangSelector>*/}
        </LoginWrapper>
      </>
    );
  }
}
const mapDispatchToProps: MapDispatchToProps<
  DispatchToProps,
  ILoginPageProps
> = () => ({
  addGuideToList: (key: string | string[]) => appDispatch(addGuideToList(key)),
});

export default connect(null, mapDispatchToProps)(LoginPage);
